export default {
  'menu.welcome': '欢迎',
  'menu.home': '首页',
  'menu.dashboard': '总览',

  'menu.admin': '用户管理',
  'menu.admin.login-info': '登录信息',
  'menu.admin.registered-users': '注册用户',
  'menu.admin.counselors': '咨询师',
  'menu.admin.consultants': '咨询者信息',

  'menu.login': '登录',
  'menu.settings': '用户设置',
  'menu.register': '注册',
  'menu.register-result': '注册结果',

  'menu.course': '课程管理',
  'menu.assessment': '测评管理',
  'menu.assessment.list': '测评量表',
  'menu.assessment.create': '创建测评量表',
  'menu.assessment.assessment-kit': '综合评测',

  'menu.comment': '评论管理',
  'menu.comment.content': '评论审核',
  'menu.comment.replay': '评论回复',

  'menu.message': '消息管理',

  'menu.order': '订单管理',
  'menu.order.list': '订单明细',
  'menu.order.profit-sharing': '分账明细',

  'menu.schedule': '排班管理',
  'menu.schedule.list': '排班管理',
  'menu.schedule.template': '班次模板',

  'menu.subscriber': '付费用户管理',
  'menu.subscriber.appointment': '预约用户管理',
  'menu.subscriber.course': '课程用户管理',
  'menu.subscriber.assessment': '测评用户管理',

  'menu.article': '文章管理',
  'menu.agreement': '协议管理',

  'menu.institution': '机构管理',

  'menu.system': '设置',
  'menu.system.users': '系统用户',
  'menu.system.user-settings': '个人设置',
  'menu.list': '列表页',
  'menu.list.table-list': '表格',

  'menu.admin.sub-page': '二级管理页',
  'menu.admin.table-list': '用户管理',
};
